import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/CustomerConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import {
  addcustomerID,
  // getCustomerList,
  workflow,
} from "../../../../redux/feature/customer_app/customerSlice";
// import CommonFillter from "../../../../Components/Filter/Supplier/SupplierCommonFillter";
import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
// import { getContactDetails } from "../../../../common/Validations";
import { SearchField } from "../../../../Components/formElements/SearchField";
import SuccessModal from "../../../../Components/Modal/supplier_app/SuccessModal";
import CreateInviteSupplierModal from "../../../../Components/Modal/supplier_app/CreateInviteSupplierModal";
import ConfirmSendInvitationModel from "../../../../Components/Modal/supplier_app/ConfirmSendInvitationModel";
import ConfirmationLoader from "../../../../Components/ConfirmationLoader";
import BroadcastModel from "../../../../Components/Modal/supplier_app/BroadcastModel";
import SupplierDeactivateModel from "../../../../Components/Modal/supplier_app/SupplierDeactivateModel";
import CreateCustomerMasterModal from "../../../../Components/Modal/customer_app/CreateCustomerMasterModal";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import { formatDateTime } from "../../../../common/Validations";
import LogisticsConstants from "../../../../common/LogisticsConstants";
import TrackModal from "./TrackModal";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import {
  addTransportNr,
  getTransportList,
} from "../../../../redux/feature/logistics_app/logisticsSlice";
import LogisticEnteryModal from "./LogisticEnteryModal";
import LogisticFuelEntryModal from "./LogisticFuelEntryModal";
import PaymentExpensesTripModel from "./PaymentExpensesTripModel";
import CommonFilterCustomerV2 from "../../../customer_app/Customer_V2/Common/CommonFilterCustomerV2";

const TransportRequestListINT = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Logistics");
  localStorage.setItem("submenu", "InTransit Trip");

  let customerData = useSelector((state) => state?.logistics?.transport); // User Details from Store

  let customerTable = useSelector(
    (state) => state?.logistics?.transport?.pagination,
  ); // User Details from Store
  let config = useSelector((state) => state?.common?.data?.suppliers); // User Details from Store

  let userData = useSelector((state) => state?.user?.data);

  const userRole = userData?.roles?.[0]?.roleId || null;


  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal /* setSendDataModal */] = useState("");
  const [modelTitle /* setModelTitle */] = useState("");

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  const [getAccountGroup, setAccountGroup] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [isPageLoading, setIsPageLoading] = useState(false); // Loading state
  const [selectedRows, setSelectedRows] = useState([]);
  /* pop success modal */
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const successModalData = {
    title: "Success",
    successMsg: "",
  };
  const [getsucceModalData, setsucceModalData] = useState(successModalData);
  const [getShowSupplierInviteModal, setShowSupplierInviteModal] =
    useState(false);
  const [getShowSendInvitationModal, setShowSendInvitationModal] =
    useState(false);
  const [getShowhideBroadcastModel, setShowhideBroadcastModel] =
    useState(false);
  const [getShowSupplierDeactivateModel, setShowSupplierDeactivateModel] =
    useState(false);
  const [filterShow, setFilterShow] = useState(false);
  const [getFilter, setFilter] = useState({});

  const onSuccessmodel = () => setShowSuccessModal(true);
  const hideSuccessModal = () => setShowSuccessModal(false);
  const hideSupplierInviteModal = () => setShowSupplierInviteModal(false);
  const hideSendInvitationModal = () => setShowSendInvitationModal(false);
  const hideBroadcastModel = () => setShowhideBroadcastModel(false);
  const hideSupplierDeactivateModel = () =>
    setShowSupplierDeactivateModel(false);
  const handleRowSelect = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };
  const sendInvitation = async () => {
    if (selectedRows.length === 0) {
      // alert("Please select at least one row.")
      successModalData.title = "Error";
      successModalData.successMsg = "Please select at least one row.";
      setsucceModalData(successModalData);
      onSuccessmodel();
      return;
    }
    try {
      setIsPageLoading(true); // Start loading
      const emailIds = selectedRows.map((row) => row.email);
      let obj = {
        email: emailIds,
      };
      await ItemService.sendInvitation(obj).then((item) => {
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const handleBroadcast = async (payload) => {
    try {
      setIsPageLoading(true); // Start loading
      const emailIds = selectedRows.map((row) => row.email);
      let obj = {
        email: emailIds,
        broadcastRemark: payload?.broadcastRemark,
      };
      await ItemService.supplierBroadcast(obj).then((item) => {
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to Broadcast:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const handleDeactivateSupplier = async (payload) => {
    try {
      setIsPageLoading(true); // Start loading
      const supplierIds = selectedRows.map((row) => row.userId);
      let obj = {
        supplierIds: supplierIds,
        remark: payload?.remark,
      };
      await ItemService.supplierDeactivate(obj).then((item) => {
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to De-activate:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const inviteSupplier = async (formData) => {
    setIsPageLoading(true); // Start loading
    try {
      await ItemService.inviteSupplier(formData).then((item) => {
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setShowSuccessModal(true);
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
          console.error("Failed to send invitation:");
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };

  //getting cutsomer ID
  const detailedPage = (transportNr) => {
    dispatch(addTransportNr(transportNr));
    navigate(LogisticsConstants.LOGISTICS_TRANSPORT_REQUEST_DETAILS);
  };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on categoryItem  Data
  // eslint-disable-next-line no-unused-vars
  const showProjectDetailsModal = (itemLevelData) => {
    setItemLevelData(
      itemLevelData?.loactionDetails[0]?.getLocations[0]?.fromToCoords,
    );
    setItemLevelColumns(projectColModal);
    setModalTitle("Project Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  /* Modal Function */

  const hideModal = () => {
    setModalShow(false);
  };

  const loadInitialSuuplierData = async () => {
    setData(customerData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      // queryName: "getLogisticsTransportList",//previous QueryName
      queryName: "getLogisticsTransportListINT",
      module: "",
      page: page,
      per_page: getNewPerPage,
      rowFilter: {
        $and: [getFilter],
      },
    };

    // dispatch(getCustomerList(obj));
    dispatch(getTransportList(obj));
    setData(customerData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      // queryName: "getLogisticsTransportList",//previous QueryName
      queryName: "getLogisticsTransportListINT",
      module: "",
      page: page,
      per_page: newPerPage,
      rowFilter: {
        $and: [getFilter],
      },
    };
    setNewPerPage(newPerPage);
    // dispatch(getCustomerList(obj));
    dispatch(getTransportList(obj));
    setData(customerData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      // queryName: "getLogisticsTransportList",//previous QueryName
      queryName: "getLogisticsTransportListINT",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    // dispatch(getCustomerList(obj));
    dispatch(getTransportList(obj));
  };

  useEffect(() => {
    const fetchData = async () => {
      await loadInitialSuuplierData();
      dispatch(workflow({}));
    };

    fetchData();

    loadInitialSuuplierData(); // fetch page 1 of users
    dispatch(workflow({}));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerData?.data]);

  //on page load
  useEffect(() => {
    dispatch(addcustomerID(""));
    let obj = {
      // queryName: "getLogisticsTransportList",//previous QueryName
      queryName: "getLogisticsTransportListINT",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getTransportList(obj));
    getMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const columns = [
    {
      name: "Trip Nr",
      id: "documentNumber",
      selector: (row) => row.documentNumber || "--",
      // sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.documentNumber)}
        >
          {row.documentNumber || "-"}{" "}
        </button>
      ),
      width: "130px",
    },
    {
      name: "Truck Nr",
      id: "vehicleNr",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">
            {row?.transportrequestDetails?.vehicleNr || row?.vehicleNr}
          </span>
        </>
      ),
      selector: (row) => row?.senderCustomerName,
      // sortable: true,
      width: "150px",
    },
    {
      name: "Driver Name",
      id: "driverName1",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">{row?.driverName1}</span>
        </>
      ),
      selector: (row) => row?.driverName1,
      // sortable: true,
      width: "150px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row?.deliveryAckStatus} />
        </>
      ),
      selector: (row) => row?.senderCustomerName,
      // sortable: true,
      width: "150px",
    },
    {
      name: "Trip Advance",
      cell: (row) => (
        <>
          {row?.driverPaymentKey === "DPA" ? (
            <span
              className="
            flex items-center justify-center
            w-9 h-9
            rounded-full
            border border-green-500
            text-green-600
            text-xl
            cursor-pointer
            hover:bg-green-100
            hover:scale-110
            transition-all
            duration-200
          "
              title="Driver payment done"
              onClick={() => showPaymentRequestModal(row)}
            >
              <i className="bi bi-currency-rupee"></i>
            </span>
          ) : (
            <button
              className="
            btnTable
            cursor-pointer
          "
              onClick={() => showPaymentRequestModal(row)}
            >
              Payment
            </button>
          )}
        </>
      ),
      width: "160px",
      omit: userRole !== "SALES-ADMIN",
    },

    {
      name: "Delivery",
      cell: (row) => (
        <>
          {row?.deliveryStatus === "DELIVERD" ? (
            <>
              <span
                style={{ marginLeft: "4px", fontSize: "0px" }}
                onClick={() => showLogistic(row)}
                className="iconTableNew"
              >
                {/* <i className="bi bi-receipt-cutoff"></i> */}
                <img
                  src="assets/img/newIcons/delivery-truck.png"
                  alt="attachments"
                  style={{ width: "60px" }}
                  className="mt-1"
                />
              </span>
            </>
          ) : (
            <>
              <button className="btnTable" onClick={() => showLogistic(row)}>
                Acceptence
              </button>
            </>
          )}
        </>
      ),
      width: "140px",
      // omit:userRole === "LOGISTICS-STAFF"
    },

    {
      name: "Payment Status",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-success-status">
            {row?.paymentStatus || "--"}
          </span>
        </>
      ),
      selector: (row) => row?.paymentStatus,
      // sortable: true,
      width: "150px",
    },
    {
      name: "Sender",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">
            {row?.senderCustomerName}
          </span>
        </>
      ),
      selector: (row) => row?.senderCustomerName,
      // sortable: true,
      width: "240px",
    },
    {
      name: "Receiver",
      selector: (row) => row?.reciverCustomerName || "--",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row?.reciverCustomerName} </p>
          {/* <p className="m-0 p-0 fw-bold">{row?.reciverCustomerName} </p> */}
        </div>
      ),
      // sortable: true,
      width: "240px",
    },
    {
      name: "Track",
      cell: (row) => (
        <>
          {/* <button type="button" class="btnTable" onClick={() => showTackModal(row)}>Track</button> */}
          <span
            style={{ marginLeft: "4px", fontSize: "0px" }}
            onClick={() => showTackModal(row)}
            className="iconTableNew"
          >
            {/* <i className="bi bi-receipt-cutoff"></i> */}
            <img
              src="assets/img/newIcons/delivery-truck.png"
              alt="attachments"
              style={{ width: "40px" }}
              className="mt-1"
            />
          </span>
        </>
      ),
      width: "120px",
      omit: true,
    },

    // {
    //   name: "Fuel Entry",
    //   cell: (row) => <button className="btnTable" onClick={()=>showFuelEnteryModla(row)}>Fuel</button>,
    //  width: "130px",
    // },

    // {
    //   name: " Sender Adress",
    //   selector: (row) => row?.senderAddress || "--",

    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1">{row?.senderAddress} </p>
    //     </div>
    //   ),
    //   // sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Receiver Adress",
    //   selector: (row) => row?.reciverAddress,
    //   // sortable: true,
    //   cell: (row) => (
    //     <>
    //       <div>
    //         <TableStatusField status={row?.reciverAddress} />
    //       </div>
    //     </>
    //   ),
    //   width: "170px",
    // },
    {
      name: "Invoice",
      cell: (row) => (
        <>
          {(row.invoiceData && (
            <img
              src="assets/img/newIcons/attached-file.png"
              className="mt-1 attachmentIcon"
              alt="attachments"
              onClick={() =>
                handleViewFile(row.invoiceData[0]?.purchaseOrderFileAttachment)
              }
            />
          )) ||
            "--"}
        </>
      ),
      width: "130px",
    },
    // {
    //   name: "Sender ContactNr",
    //   cell: (row) => (
    //     <>
    //       <TableStatusField status={row?.senderContactNumber} />
    //     </>
    //   ),
    //   selector: (row) => row?.senderContactNumber || "--",
    //   // sortable: true,
    //   width: "150px",
    // },
    {
      name: "Created Date",
      id:"createdAt",
      selector: (row) => formatDateTime(row.createdAt),
      sortable: true,
      width: "160px",
    },
  ];

  const projectColModal = [
    {
      name: "Project Code",
      cell: (row) => <span>{row.projectCode} </span>,
      width: "180px",
    },
    {
      name: "Project Name",
      cell: (row) => <span>{row.projectName} </span>,
      width: "180px",
    },
    {
      name: "Project Location",
      cell: (row) => (
        <span>
          {row.getLocations?.length > 0
            ? row.getLocations[0]?.projectLocation
            : ""}
        </span>
      ),
      width: "180px",
    },
    {
      name: "Project State",
      cell: (row) => <span>{row.projectState} </span>,
      width: "180px",
    },
    {
      name: "Project Country",
      cell: (row) => <span>{row.projectCountry} </span>,
      width: "180px",
    },
  ];
  const getMasterData = async () => {
    let obj = {
      codeType: "accountGroup",
    };
    await ItemService.getMasterData(obj).then((item) => {
      if (item?.status === 200) {
        setAccountGroup(item?.data);
      } else {
        setAccountGroup([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const handleCustomerRegister = () => {
    navigate(LogisticsConstants.LOGISTICS_TRANSPORT_REQUEST_CREATE);
  };

  //track Modal
  const [getTackLineItemdData, setTackLineItemdData] = useState();
  const [getTrackModal, setTrackModal] = useState(false);
  const showTackModal = (item) => {
    setTackLineItemdData(item);
    setTrackModal(true);
  };
  const hideTrackModal = () => {
    setTrackModal(false);
  };

  //logsitic modal

  //track Modal
  const [getLogisticData, setLogisticData] = useState();

  const [getLogisticModal, setLogisticModal] = useState(false);
  // eslint-disable-next-line
  const showLogistic = (item) => {
    setLogisticData(item);
    setLogisticModal(true);
  };
  const hideLogisticModal = () => {
    setLogisticModal(false);
  };
  //fule entery Modal
  const [modalShowFuelEntery, setModalShowFuelEntery] = useState(false);
  const [estimationFuelEnteryData, setEstimationFuelEnteryData] = useState("");

  // eslint-disable-next-line
  const showFuelEnteryModla = (data) => {
    //call this one in button to bring pop up
    setModalShowFuelEntery(true);
    setEstimationFuelEnteryData(data);
  };

  const hideModalFuelEntery = () => {
    setModalShowFuelEntery(false);
  };

  //payment trip model
  const [modalPaymentRequestShowStatus, setModalPaymentRequestShowStatus] =
    useState(false);
  const [getModalPaymentRequestData, setModalPaymentRequestData] = useState();

  const showPaymentRequestModal = (data) => {
    setModalPaymentRequestShowStatus(true);
    setModalPaymentRequestData(data);
  };

  const hidePaymentModalStatus = () => {
    setModalPaymentRequestShowStatus(false); //hide cash request modal
  };
  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "getLogisticsTransportListINT",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    setFilter(filters);
    dispatch(getTransportList(obj));
  };
  return (
    <main className="dashboard main" id="main">
      {/* Spinner Overlay */}
      <ConfirmationLoader isPageLoading={isPageLoading} />
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">In Transit Trip List</h2>
                <p className="subText">Trip Directory and Overview </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
               
              </Col>
               <Col xs={4} md={1} lg={1}>
                  <span
                    className="filterIcon"
                    onClick={() => setFilterShow(!filterShow)}
                  >
                    <i className="bi bi-filter"></i>
                  </span>
                </Col>
            </Row>
            <hr />
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <CommonFilterCustomerV2
                    getfiltereddata={columns}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      // console.log(">>Received filters from child:", filters);
                      // const filterData=[filters]
                      handleAdvanceSearchFuncApi(filters);
                      // You can now use the filters here
                    }}
                  />
                )}
              </Col>
            </Row>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">TL</span>
                    </Col>
                    <Col xs={8} md={3} lg={3}>
                      <span className="headerTitle">Trip List</span>
                      <span className="subHeaderTitle">
                        View of Trip and Status{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={7} lg={7} className="headerButtonAlign">
                      <Col xs={4} md={2} lg={2} className="me-2">
                        <button
                          className="btnTable"
                          onClick={handleCustomerRegister}
                        >
                          <i className="bi bi-person-plus"></i> Add Trip
                        </button>
                      </Col>

                      {/* {config?.deactivateListBtn && (
                        <Col xs={4} md={2} lg={2} className="btnSpaceInMobile">
                          <button
                            className="btnTable"
                            onClick={() => setShowSupplierDeactivateModel(true)}
                          >
                            Deactivate List
                          </button>
                        </Col>
                      )} */}

                      {config?.filter && (
                        <Col xs={2} md={1} lg={1} className="">
                          <>
                            <div className="filter">
                              <span
                                className="icon hide headerIcon"
                                data-bs-toggle="dropdown"
                                aria-expanded="true"
                              >
                                <i className="bi bi-three-dots"></i>
                              </span>
                              <ul
                                className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                                data-popper-placement="bottom-end"
                              >
                                <li className="dropdown-header text-start">
                                  <h6>Menu</h6>
                                </li>

                                <li>
                                  <span
                                    className="dropdown-item headerIcon"
                                    onClick={() => handleSearchFuncApi()}
                                  >
                                    <i className="bi bi-arrow-clockwise"></i>
                                    Refresh Data
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={customerData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={customerTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelect}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CreateCustomerMasterModal
        show={modalShow}
        onHide={() => hideModal()}
        dropdownData={getAccountGroup}
      />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
      />
      <CreateInviteSupplierModal
        show={getShowSupplierInviteModal}
        onHide={hideSupplierInviteModal}
        onSubmit={inviteSupplier}
      />
      <ConfirmSendInvitationModel
        show={getShowSendInvitationModal}
        onHide={hideSendInvitationModal}
        onSubmit={sendInvitation}
        selectedRows={selectedRows}
      />
      <BroadcastModel
        show={getShowhideBroadcastModel}
        onHide={hideBroadcastModel}
        onSubmit={handleBroadcast}
        selectedRows={selectedRows}
      />
      <SupplierDeactivateModel
        show={getShowSupplierDeactivateModel}
        onHide={hideSupplierDeactivateModel}
        onSubmit={handleDeactivateSupplier}
        selectedRows={selectedRows}
      />

      <TrackModal
        show={getTrackModal}
        onHide={() => hideTrackModal(getTrackModal)}
        data={getTackLineItemdData}
        // onSuccess={() => handleSearchFuncApi()}
      />
      <LogisticEnteryModal
        show={getLogisticModal}
        onHide={() => hideLogisticModal(getLogisticModal)}
        data={getLogisticData}
        // onSuccess={() => handleSearchFuncApi()}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <LogisticFuelEntryModal
        show={modalShowFuelEntery}
        onHide={() => hideModalFuelEntery()}
        data={estimationFuelEnteryData}
      />
      <PaymentExpensesTripModel
        show={modalPaymentRequestShowStatus}
        onHide={() => hidePaymentModalStatus()}
        data={getModalPaymentRequestData}
      />
    </main>
  );
};

export default TransportRequestListINT;
